export default "__VITE_ASSET__DF9L1Qyn__"